import { TableColumnType } from 'antd';

export const sizeColumns = <T>(columns: TableColumnType<T>[], sizes: (string | number | undefined)[]) =>
  columns.map((column, index) => ({ ...column, width: sizes[index] }));
